'use client';

import { type JSX, useState } from 'react';
import { useBooking } from '../../context/BookingContext';

/**
 * « Appeler » : sortie des prestations non réservables en ligne et des semaines sans créneau (spec Parcours
 * § 7.8). Le numéro est un binding protégé : révélé au premier clic (captcha, `onRevealProPhone`), le second
 * clic appelle (`tel:`), comme `BookingSuspendedCard`. Sans callback, rien n'est rendu.
 */
export function CallProButton({ className }: { className?: string }): JSX.Element | null {
  const { callbacks, labels, professionalName } = useBooking();
  const [phone, setPhone] = useState<string | null>(null);
  const [revealing, setRevealing] = useState(false);
  const reveal = callbacks.onRevealProPhone;
  if (!reveal) return null;

  const callLabel = professionalName ? labels.call_pro_named.replace('{name}', professionalName) : labels.call_pro;
  const classes = `bt-cta bt-cta--small bt-cta--secondary${className ? ` ${className}` : ''}`;

  if (phone) {
    return (
      <a className={classes} href={`tel:${phone.replace(/[^\d+]/g, '')}`}>
        {`${callLabel} : ${phone}`}
      </a>
    );
  }

  const handleReveal = async (): Promise<void> => {
    if (revealing) return;
    setRevealing(true);
    try {
      setPhone(await reveal());
    } catch {
      // Silencieux : le bouton garde son libellé, le visiteur peut réessayer.
    } finally {
      setRevealing(false);
    }
  };

  return (
    <button type="button" className={classes} disabled={revealing} onClick={(): void => void handleReveal()}>
      {revealing ? labels.call_pro_loading : callLabel}
    </button>
  );
}
